import { render, staticRenderFns } from "./FundMapList.vue?vue&type=template&id=389d0a84&scoped=true"
import script from "./FundMapList.vue?vue&type=script&lang=js"
export * from "./FundMapList.vue?vue&type=script&lang=js"
import style0 from "./FundMapList.vue?vue&type=style&index=0&id=389d0a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d0a84",
  null
  
)

export default component.exports